module.exports = __webpack_public_path__ + "static/media/account.8ca8f710.svg";